import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';

import type { FC } from 'react';
import { World } from 'types/shared/worlds';
import { getTracingEvents } from 'utils/amplitude';
import type { CheckboxProps } from './Checkbox.types';

const themes: Record<string, string | undefined> = {
  [World.BANK]: 'text-bank focus:ring-bank-200 focus:border-bank',
  [World.EXPENSES]:
    'text-expenses focus:ring-expenses-200 focus:border-expenses',
  [World.REVENUES]:
    'text-revenues focus:ring-revenues-200 focus:border-revenues ',
  [World.TAXES]: 'text-taxes focus:ring-taxes-200 focus:border-taxes',
  primary: 'text-primary focus:ring-primary-200 focus:border-primary',
};

const Checkbox: FC<CheckboxProps> = ({
  className,
  color,
  disabled,
  onChange,
  tracingEvent,
  ...props
}) => {
  const tracingEvents = getTracingEvents(
    tracingEvent ? { onChange: tracingEvent } : {},
    { onChange },
  );
  const theme = useWorldTheme();
  const themeColor = themes[color || theme] || themes.primary;
  return (
    <input
      {...props}
      type="checkbox"
      className={classNames(
        'h-4 w-4 focus:ring-1 rounded-[3px] shadow-checkbox allow-focus-shadow cursor-pointer transition-colors tranisiton-shadow border-primary-100 hover:border-primary-200 outline-none focus:ring-offset-0',
        themeColor,
        className,
        { 'cursor-not-allowed !border-gray-200': disabled },
      )}
      disabled={disabled}
      onChange={disabled ? undefined : tracingEvents.onChange}
    />
  );
};

export default Checkbox;
